// utils/helpers.js — shared constants and utilities

export const AVATAR_COLORS = [
  '#c47c3a','#2d5c3c','#5a2d6e','#7c2d4a','#1e6fa8',
  '#b8962e','#3d2210','#0a66c2','#e1306c','#2e7d32',
];

export function avatarColor(str) {
  return AVATAR_COLORS[((str || '?').charCodeAt(0)) % AVATAR_COLORS.length];
}

export function makeInitials(name) {
  return (name || '?').split(' ').map(w => w[0] || '').join('').toUpperCase().slice(0, 2) || '?';
}

export function esc(s) {
  return String(s || '')
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

export const CHANNEL_META = {
  linkedin:  { label:'LinkedIn',      color:'#0a66c2', bg:'#e8f0fb', emoji:'💼', maxChars:1300 },
  facebook:  { label:'Facebook',      color:'#1877f2', bg:'#e8f0ff', emoji:'📘', maxChars:500  },
  instagram: { label:'Instagram',     color:'#e1306c', bg:'#fce4ec', emoji:'📸', maxChars:2200 },
  blog:      { label:'Blog Post',     color:'#2e7d32', bg:'#e8f5e9', emoji:'✍️', maxChars:null },
  partner:   { label:'Partner Brief', color:'#f57f17', bg:'#fff8e1', emoji:'🤝', maxChars:null },
};

export const URGENCY_META = {
  hot:     { label:'🔥 Hot',     bg:'#fce8ef', color:'#7c2d4a' },
  soon:    { label:'⏰ Soon',    bg:'#fdf3d8', color:'#b8962e' },
  anytime: { label:'🌿 Anytime', bg:'#e4efe6', color:'#2d5c3c' },
};

export const CATEGORY_META = {
  customer:       { label:'Customer',       bg:'#e8f0fb', color:'#0a66c2' },
  tradeshow:      { label:'Tradeshow',      bg:'#fdf3d8', color:'#b8962e' },
  partner:        { label:'Partner',        bg:'#fff8e1', color:'#f57f17' },
  sustainability: { label:'Sustainability', bg:'#e4efe6', color:'#2d5c3c' },
  product:        { label:'Product',        bg:'#f3eaf8', color:'#5a2d6e' },
  recipe:         { label:'Recipe',         bg:'#fce4ec', color:'#e1306c' },
  lifestyle:      { label:'Lifestyle',      bg:'#fdf0e3', color:'#c47c3a' },
  quote:          { label:'Quote',          bg:'#e0edf8', color:'#1e6fa8' },
  education:      { label:'Education',      bg:'#e4efe6', color:'#2d5c3c' },
  other:          { label:'Other',          bg:'#f3f4f6', color:'#6b7280' },
};

export const TONE_OPTIONS = [
  { id:'conversational',  label:'Conversational'  },
  { id:'educational',     label:'Educational'     },
  { id:'inspirational',   label:'Inspirational'   },
  { id:'professional',    label:'Professional'    },
  { id:'storytelling',    label:'Storytelling'    },
  { id:'data_driven',     label:'Data-Driven'     },
  { id:'humorous',        label:'Humorous'        },
  { id:'urgent',          label:'Urgent'          },
];

export function formatDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' });
}

export function formatTime(iso) {
  if (!iso) return '';
  const d    = new Date(iso);
  const now  = new Date();
  const diff = (now - d) / 1000;
  if (diff < 60)    return 'just now';
  if (diff < 3600)  return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return formatDate(iso);
}

export function charCountColor(count, max) {
  if (!max)              return '';
  if (count > max)       return 'over';
  if (count > max * 0.9) return 'warn';
  return '';
}
